import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("meteoseba_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function fileUrl(path) {
  if (!path) return "";
  return `${API}/files/${path}`;
}

// Wind rating helpers (knots) for windsurf/kite conditions
export function ratingFromKnots(kn) {
  if (kn == null) return { key: "unknown", label: "N/D", color: "slate" };
  if (kn < 6) return { key: "flat", label: "Piatto", color: "sky" };
  if (kn < 12) return { key: "light", label: "Leggero", color: "cyan" };
  if (kn < 25) return { key: "good", label: "Ottimo", color: "emerald" };
  if (kn < 35) return { key: "strong", label: "Forte", color: "orange" };
  return { key: "extreme", label: "Estremo", color: "red" };
}

export const RATINGS = [
  { key: "flat", label: "Piatto", color: "sky" },
  { key: "light", label: "Leggero", color: "cyan" },
  { key: "good", label: "Ottimo", color: "emerald" },
  { key: "strong", label: "Forte", color: "orange" },
  { key: "extreme", label: "Estremo", color: "red" },
];

export function ratingMeta(key) {
  return RATINGS.find((r) => r.key === key) || { key, label: key, color: "slate" };
}

export const SEBA_IMG =
  "https://customer-assets.emergentagent.com/job_seba-wave-monitor/artifacts/q8juomzd_IMG_5254.webp";
